import useSWR from "swr";

import { getUserMiniLeagues } from 'api/user';
import useUser from "hooks/useUser";

function useMiniLeagues() {

    const { loggedOut } = useUser();

    const fetcher = async () => {
        const response = await getUserMiniLeagues();
        return response.data;
    }

    const { data, error, isLoading, mutate } = useSWR(
        loggedOut ? null : 'mini-leagues',
        fetcher
    );

    return {
        miniLeagues: data,
        isLoading,
        isError: !!error,
        mutateMiniLeagues: mutate
    }
}

export default useMiniLeagues;
